import React from 'react';
import Image from 'next/image';
import {useRouter} from 'next/router';
function Error({statusCode}) {
	const router = useRouter();
	return (
		<div className='container text-center'>
			<Image
				src='/assets/images/notFound.png'
				alt='not Found'
				width={500}
				height={500}
			/>
			<div id='info'>
				<h3>
					{statusCode
						? `An error ${statusCode} occurred on server`
						: 'This page could not be found'}
				</h3>
				<button
					type='button'
					className='btnCustom'
					style={{
						width: '200px',
						margin: '0 auto',
						backgroundColor: '#8EBDC1',
					}}
					onClick={() => router.push('/')}
				>
					Back to Home
				</button>
			</div>
		</div>
	);
}

Error.getInitialProps = ({res, err}) => {
	const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
	return {statusCode};
};

export default Error;
